import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight } from '@fortawesome/pro-light-svg-icons'

import { Box, DashboardModuleListItem } from '@domain-group/suit-theme'

import useProcessingFee from '@hooks/useProcessingFee'

import type { ProcessingFeeModel } from '@models/types'

type ProcessingFeeProps = {
  callbacks: {
    confirmDelete: Function,
  },
  isMasterAdmin: boolean,
  processingFee: ProcessingFeeModel,
}

const ProcessingFee = (props: ProcessingFeeProps) => {
  const { callbacks: { confirmDelete }, isMasterAdmin, processingFee: initProcessingFee } = props

  const processingFeePayload = useProcessingFee(initProcessingFee)

  const {
    callbacks: {
      createOrEditProcessingFee,
      deleteProcessingFee: deleteFn,
    },
    processingFee: { value },
    serviceProduct,
    valueText,
  } = processingFeePayload

  const { id, reference_title, title } = serviceProduct || {}

  const referenceTitle = reference_title ? `${reference_title} - ` : ''

  return (
    <DashboardModuleListItem
      secondaryText={<Box marginLeft="large">{referenceTitle}# {id}</Box>}
      title={(
        <Box alignItems="center">
          <Box color="faintGrey" marginRight="medium" width="fit-content">
            <FontAwesomeIcon icon={faAngleRight} />
          </Box>
          {title}
        </Box>
      )}
    >
      {!!value && (
        // @ts-expect-error TS2339
        <DashboardModuleListItem.TertiaryText>
          {valueText}
          {/*
          // @ts-expect-error TS2339 */}
        </DashboardModuleListItem.TertiaryText>
      )}

      {isMasterAdmin && (
        // @ts-expect-error TS2339
        <DashboardModuleListItem.Actions>
          {/*
           // @ts-expect-error TS2339 */}
          <DashboardModuleListItem.Icon
            marginRight="medium"
            onClick={() => createOrEditProcessingFee()}
            type="edit"
          />

          {/*
           // @ts-expect-error TS2339 */}
          <DashboardModuleListItem.Icon
            onClick={() => confirmDelete(deleteFn)}
            type="delete"
          />
          {/*
          // @ts-expect-error TS2339 */}
        </DashboardModuleListItem.Actions>
      )}
    </DashboardModuleListItem>
  )
}

export default ProcessingFee
